module.exports = __webpack_public_path__ + "img/1(12).2e01e8be.png";